import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  CardMedia,
  CardHeader,
  CardContent,
  CircularProgress,
  IconButton,
  Backdrop,
  Button,
  styled,
  useTheme,
  Stack,
  Typography,
  Icon,
} from "@mui/material";
import { ArrowBack, NavigateNext } from "@mui/icons-material";
import { format as DateFormat } from "date-fns";
import { useSnackbar } from "notistack";
import {
  GetNotificaciones,
  SendPublicacion,
} from "../../redux/actions/notificaciones";
import {
  getNotificaciones,
  getCargando,
  getPublicaciones,
  getMensaje,
} from "../../redux/selectors";
import { RemMensaje } from "../../redux/actions/mensajes";
import Imagen from "./imagen";
import Publicacion from "./publicacion";

import esLocale from "date-fns/locale/es";

const Difusion = (props) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const paramsIng = useParams();
  const { enqueueSnackbar /*, closeSnackbar*/ } = useSnackbar();
  const mensaje = useSelector((state) => getMensaje(state));
  const [params, setParams] = React.useState(null);
  const tileData = useSelector((state) => getNotificaciones(state));
  const backdrop = useSelector((state) => getCargando(state));
  const pubData = useSelector((state) => getPublicaciones(state));
  const [pv, setPv] = React.useState(null);

  const StyledCardHeader = styled(({ ...other }) => <CardHeader {...other} />)`
    & .MuiCardHeader-content {
      flex: 1 1 auto;
      width: 100%;
    }
  `;
  React.useEffect(() => {
    if (paramsIng.modo && paramsIng.modo === "1")
      document.body.style.backgroundColor = "#2f3035";
    const p = {
      guid: paramsIng.guid,
      padre: 0,
      modo: paramsIng.modo,
    };
    setParams(p);

    dispatch(GetNotificaciones(p));
  }, []);
  React.useEffect(() => {
    if (mensaje.mensaje !== "") {
      enqueueSnackbar(mensaje.mensaje, {
        preventDuplicate: true,
        anchorOrigin: { vertical: "bottom", horizontal: "center" },
        variant: mensaje.variant,
        autoHideDuration: 3000,
      });
      dispatch(RemMensaje());
    }
  }, [mensaje]);

  const backClic = () => {
    const p = {
      guid: paramsIng.guid,
      padre: 0,
      modo: paramsIng.modo,
    };
    setParams(p);
    // setPv(null);
    dispatch(GetNotificaciones(p));
  };
  const fowardClic = (index) => {
    const p = {
      guid: paramsIng.guid,
      padre: index,
      modo: paramsIng.modo,
    };
    setParams(p);
    setPv(null);
    dispatch(GetNotificaciones(p));
  };
  const fowardClicPV = (index) => {
    const p = {
      guid: paramsIng.guid,
      padre: index,
      modo: paramsIng.modo,
    };
    setParams(p);
    setPv((pubData && pubData.find((x) => x.Id === index)) || null);
  };
  return (
    <Stack
      sx={{
        padding: theme.spacing(2, 0, 2),
        overflowY: "auto",
        maxHeight: "100vh",
      }}
    >
      <Container
        sx={{
          pt: 2,
          pb: 2,
        }}
      >
        <Backdrop
          sx={{
            zIndex: theme.zIndex.drawer + 1,
          }}
          open={backdrop}
        >
          <CircularProgress
            sx={{
              color: "#006699",
              m: "auto",
            }}
          />
        </Backdrop>
        <Grid
          sx={{ display: (backdrop && "none") || "inherits" }}
          container
          spacing={params && params.padre > 0 ? 2 : 4}
        >
          {params &&
            params.padre === 0 &&
            pubData &&
            pubData.map((pv, index) => (
              <Grid key={"1002" + index} size={12}>
                <Card
                  sx={{
                    height: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: pv.Respuestas
                      ? theme.palette.success.light
                      : theme.palette.background.paper,
                  }}
                  variant="outlined"
                >
                  <CardHeader
                    title={pv && pv.Nombre}
                    slotProps={{
                      title: { variant: "h6" },
                      subheader: { fontSize: "small" },
                    }}
                    subheader={
                      pv && (
                        <Stack direction="column">
                          <Stack direction="row">
                            <Typography variant="caption">
                              {DateFormat(new Date(pv.Desde), "dd/MM/yyyy")}
                            </Typography>
                            <Stack sx={{ flexGrow: 1 }} />
                            <Typography variant="caption">
                              {DateFormat(new Date(pv.Hasta), "dd/MM/yyyy")}
                            </Typography>
                          </Stack>
                          <Typography variant="caption">
                            {pv.Descripcion}
                          </Typography>
                        </Stack>
                      )
                    }
                    action={
                      <IconButton onClick={(e) => fowardClicPV(pv.Id)}>
                        <Icon>navigate_next</Icon>
                      </IconButton>
                    }
                  />
                  <CardContent>
                    <Typography style={{ marginTop: "16px" }}>
                      {pv.Respuestas ? "Realizado." : "Pendiente."}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}

          {params && params.padre > 0 && (
            <Grid key={1000} size={12}>
              <Button
                sx={{
                  color: "#006699",
                  m: "auto",
                }}
                size="small"
                onClick={backClic}
                startIcon={<ArrowBack />}
              >
                Atras
              </Button>
            </Grid>
          )}
          {params && params.padre > 0 && pv && (
            <Grid key={1002} size={12}>
              <Publicacion
                datos={pv}
                onSend={(lista) =>
                  dispatch(
                    SendPublicacion({
                      GUID: paramsIng.guid,
                      ID_PUBLICACION: pv.Id,
                      respuesta: lista,
                    }),
                  )
                }
              />
            </Grid>
          )}

          {params &&
            !backdrop &&
            params.padre === 0 &&
            !pubData &&
            tileData &&
            tileData.length === 0 && (
              <Grid key={1001} size={12}>
                <Card
                  sx={{
                    height: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  variant="outlined"
                >
                  <CardHeader subheader={"No hay publicaciones para ver."} />
                </Card>
              </Grid>
            )}

          {params &&
            params.padre === 0 &&
            tileData &&
            tileData.map((card, index) => (
              <Grid key={index} size={12}>
                <Card
                  sx={{
                    height: "100%",
                    minHeight: "100px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                  variant="outlined"
                >
                  {card.Titulo && (
                    <StyledCardHeader
                      title={card.Titulo}
                      titleTypographyProps={{
                        variant: "h6",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                      }}
                      subheader={DateFormat(
                        new Date(card.Fecha),
                        "dd 'de' MMMM 'de' yyyy",
                        {
                          locale: esLocale,
                        },
                      )}
                      subheaderTypographyProps={{ variant: "caption" }}
                      action={
                        card.cantHijos > 1 && (
                          <IconButton
                            onClick={(e) => {
                              card.cantHijos > 1 && fowardClic(card.Id);
                            }}
                          >
                            <NavigateNext />
                          </IconButton>
                        )
                      }
                    />
                  )}
                  {card.IMG ? (
                    <CardMedia
                      sx={{
                        backgroundSize: "contain",
                      }}
                      image={card.IMG}
                      title={card.Titulo}
                      component={card.Src}
                      controls
                      preload="none"
                      onClick={(e) => {
                        if (card.Url && card.Url !== null && card.Url !== "")
                          window.location.href = card.Url;
                        else card.cantHijos > 1 && fowardClic(card.Id);
                      }}
                    />
                  ) : (
                    <CardContent
                      sx={{
                        height: "100%",
                        width: "100%",
                      }}
                    >
                      <Stack
                        sx={{
                          width: "100%",
                          height: "100%",
                          alignItems: "center",
                          alignContent: "center",
                        }}
                      >
                        <CircularProgress
                          sx={{
                            color: "#006699",
                            m: "auto",
                          }}
                        />
                      </Stack>
                    </CardContent>
                  )}
                </Card>
              </Grid>
            ))}

          {params &&
            params.padre > 0 &&
            !pv &&
            tileData &&
            tileData.map((card, index) => (
              <Imagen key={index} index={index} card={card} />
            ))}
        </Grid>
      </Container>
    </Stack>
  );
};

export default Difusion;
